import React, { createContext, useReducer, useMemo } from 'react';

const initialState = {
    installEvent: null,
    displayMode: 'standalone'
};

const actions = {
    SET_INSTALL_EVENT: 'SET_INSTALL_EVENT',
    SET_DISPLAY_MODE: 'SET_DISPLAY_MODE'
};

function reducer(state, action) {
    switch (action.type) {
        case actions.SET_INSTALL_EVENT:
            return { ...state, installEvent: action.value };
        case actions.SET_DISPLAY_MODE:
            return { ...state, displayMode: action.value };
        default:
            return state;
    }
}

export const InstallButtonContext = createContext();

const InstallButtonContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);

    const value = useMemo(() => ({
        installEvent: state.installEvent,
        displayMode: state.displayMode,
        setInstallEvent: (innerValue) => dispatch({ type: actions.SET_INSTALL_EVENT, value: innerValue }),
        setDisplayMode: (innerValue) => dispatch({ type: actions.SET_DISPLAY_MODE, value: innerValue }),
    }), [state, dispatch]);

    return (
        <InstallButtonContext.Provider value={value}>
            {children}
        </InstallButtonContext.Provider>
    );
}

export default InstallButtonContextProvider;
